/* eslint-disable prettier/prettier */
import { ContentType } from '../ContentType';
import { Messages } from '../../../../gen-src/Localize';
import { IContentDefinition } from './IContentDefinition';
import { CommonColumns, IColumnFactoryParameters } from '../../components/listView/ListViewGridColumnGenerator';
import { SearchResponseHitsContent } from '../../../generated/content-exploration';
import GetMetaDataRequests from '../../services/httpClient/GetMetaDataRequests';
import { GetPredictiveModelsResult } from '../httpClient/MetaDataResults';
import { PredictiveModel } from '../SearchResultTypes';
import { SortBy } from '../SortSelection';
import { defaultHeaderFormatter } from '../../components/listView/DefaultHeaderFormatter';
import { UserMapper } from '../../../common/utils/UserMapper';
import { AppUrls } from '../../../app/AppUrls';
import { DateTimeCell } from '../../components/listView/dataGridCells/DateTimeCells';
import { LocationTypes } from '../ILocationInfo';
import { ConnectedOwnerFilter } from '../../components/filters/quickFilter/OwnerFilter';
import { ConnectedModifiedTimeFilter } from '../../components/filters/quickFilter/ModifiedTimeFilter';
import { FeatureFlag, FeatureFlagService } from '../../services/FeatureFlagService';
import { ConnectedTagFilter } from '../../components/filters/quickFilter/TagFilter';

export const predictiveModelContentDefinition: IContentDefinition<PredictiveModel, GetPredictiveModelsResult> = {
  getSectionTitle: () => Messages.PredictiveModelsSectionTitle(),
  getUrl: (urls) => urls.searchPredictiveModelsUrl(),
  getPath: (urls) => urls.searchPredictiveModelsPath(),
  contentSpaceUrl: (urls: AppUrls, contentId: string) => urls.predictiveModelUrl(contentId),
  quickFilters: [ConnectedOwnerFilter, ConnectedModifiedTimeFilter, ConnectedTagFilter],
  defaultDisplayMode: 'list',
  maxItemCountInMixedContentTypeResultPage: 4,
  getListViewColumns: () => [
    CommonColumns.name,
    CommonColumns.owner,
    CommonColumns.location,
    (parameters: IColumnFactoryParameters) => {
      return {
        name: 'modified',
        dataKey: 'modifiedTime',
        sortable: false,
        headerText: Messages.column_updated(),
        direction: 'desc',
        growToFit: true,
        headerFormatter: defaultHeaderFormatter(),
        cellFormatter: DateTimeCell('modifiedTime'),
      };
    },
    CommonColumns.description,
  ],
  mapCRASSData: (crassData: SearchResponseHitsContent[]) => {
    return crassData.map((crassDataItem: SearchResponseHitsContent) => {
      return {
        crassData: crassDataItem,
        contentType: ContentType.predictivemodel,
        name: crassDataItem.title,
        id: crassDataItem.id.toString(),
        location: {
          name: crassDataItem.containerName || '',
          id: crassDataItem.projectId?.toString() || '',
          type: crassDataItem.containerType as LocationTypes,
        },
        modifiedTime: crassDataItem.modifiedTime || '',
        createdAt: crassDataItem.createdTime || '',
        description: crassDataItem.description || '',
        owner: UserMapper.mapOne({
          displayName: crassDataItem.ownerName || '',
          username: crassDataItem.ownerAlias || '',
          domainName: crassDataItem.ownerDomain,
          id: crassDataItem.ownerId?.toString() || '',
        }),
      };
    });
  },
  mapMetadata: (searchResultItems, metadata) => {
    return searchResultItems.map((searchResultItem) => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      return {
        ...searchResultItem,
      };
    });
  },
  getMetaDataRequests: GetMetaDataRequests.GetPredictiveModelsRequest,
  getSortOptions: () => [SortBy.getRelevancySortSelection()],
  shouldBeAvailable: () => FeatureFlagService.instance.getValue(FeatureFlag.predictiveModelEnabled),
  favoritable: () => false,
};
